export const environment = {
  production: true,
  API_URL: 'https://api.infistel.pe/api/',
  API_VERSION: 'v1',
  SPEEDTEST_URL: 'https://speedtest.infistel.pe',
  SPEED_TEST_MODE: 'scenario' as 'live' | 'scenario',
  API_CULQI: 'https://api.culqi.com/v2/',
  PUBLIC_KEY_CULQI: 'pk_live_69304ac90c70b4c7',
  PRIVATE_KEY_CULQI: 'Bearer sk_live_c3a99bf21f4233e5',

  NETWORK_CONTEXT_URL: 'https://cliente.infistel.pe/network-context',

  SPEEDTEST_SERVER_NAME: 'Infistel',

  SPEEDTEST_SERVER_LOCATION: 'Huánuco',
};
